// extracted by mini-css-extract-plugin
export var popover = "DropdownPriceFilter_popover__6EOY8";
export var inputGrid = "DropdownPriceFilter_inputGrid__cppJo";
export var textError = "DropdownPriceFilter_textError__sJVY1";
export var btnApply = "DropdownPriceFilter_btnApply__YS4fN";
export var rotate = "DropdownPriceFilter_rotate__XyEVt";
export var dotty = "DropdownPriceFilter_dotty__rZC+J";